import './HomeScreenStyles.scss';
import { Container } from '@custom/dx3';
import { type FC } from 'react';
import { COPY as ALL_COPY } from '../../assets/copy/copy';
import DashboardSection from '../../sections/DashboardSection/DashboardSection';
import { MissionsSection } from '../../sections/MissionsSection/MissionsSection';

const COPY = ALL_COPY.HOME_SCREEN;

export const HomeScreen: FC = () => {
  return (
    <Container className="home-screen-container">
      <div className="home-screen-top-row">
        <div>
          <h2 className="page-title">{COPY.HEADER}</h2>
        </div>
      </div>
      <DashboardSection />
      <MissionsSection />
    </Container>
  );
};
